<template>
  <div>
    <header
      class="container d-flex align-items-center justify-content-between px-lg-1 px-3 py-2 py-md-0"
    >
      <div
        class="d-lg-flex d-none align-items-center justify-content-start flex-grow-1"
      >
        <MegaMeun />
      </div>

      <div
        class="d-lg-flex d-none align-items-center justify-content-center flex-grow-1 py-4 py-lg-2 logo-header"
      >
        <Logo />
      </div>

      <div class="d-flex d-lg-none align-items-center justify-content-start">
        <button
          type="button"
          id="all-categories"
          class="all-categories bg-transparent resp-menu-btn d-lg-none"
          @click="$emit('openRespMenu')"
        >
          <MenuBar />
        </button>
        <Logo />
      </div>
      <div
        class="d-flex align-items-center justify-content-end flex-grow-1 header-icons"
      >
      <HeaderNotification
          v-if="notifications"
          v-show="notifications.items && notifications.items.length"
          v-model="notifications"
        />
        <a
             v-if="!loading"
             :href="!loading ? insta?.instagram : ''"
             class="mx-2 d-inline-block social-icon-footer"
           >
             <svg
               width="20"
               height="20"
               version="1.1"
               id="Capa_1"
               xmlns="http://www.w3.org/2000/svg"
               xmlns:xlink="http://www.w3.org/1999/xlink"
               x="0px"
               y="0px"
               viewBox="0 0 512 512"
               style="enable-background: new 0 0 512 512"
               xml:space="preserve"
             >
               <path
                 d="M352,0H160C71.648,0,0,71.648,0,160v192c0,88.352,71.648,160,160,160h192c88.352,0,160-71.648,160-160V160
                             C512,71.648,440.352,0,352,0z M464,352c0,61.76-50.24,112-112,112H160c-61.76,0-112-50.24-112-112V160C48,98.24,98.24,48,160,48
                             h192c61.76,0,112,50.24,112,112V352z"
                 fill="#000"
               />
               <path
                 d="M256,128c-70.688,0-128,57.312-128,128s57.312,128,128,128s128-57.312,128-128S326.688,128,256,128z M256,336
                             c-44.096,0-80-35.904-80-80c0-44.128,35.904-80,80-80s80,35.872,80,80C336,300.096,300.096,336,256,336z"
                 fill="#000"
               />
               <circle cx="393.6" cy="118.4" r="17.056" fill="#000" />
             </svg>
        </a>
        <button
          class="bg-transparent"
          type="button"
          @click="showCloseSearchBox()"
        >
          <searchSvg />
        </button>

        <button class="bg-transparent" type="button" @click="cartListsOpen()">
          <CartButton />
        </button>
        <LoginUser :atlasTheme="true" />
      </div>
    </header>
  </div>
</template>

<script>
import searchSvg from "./svg/Search.vue";
import CartButton from "./cart/CartButton.vue";
import { cartListsOpen, openSearch } from "@/libraries/functions";
import Logo from "@/parts/Front/components/AtlasLogo";
import MegaMeun from "../components/MegaMenu.vue";
import LoginUser from "@/parts/Front/components/LoginUser";
import UserSvg from "./svg/User.vue";
import HeaderNotification from "@/parts/Front/components/notification/HeaderNotification";
import MenuBar from "./svg/MenuBar.vue";
export default {
  components: {
    searchSvg,
    Logo,
    MegaMeun,
    CartButton,
    LoginUser,
    UserSvg,
    MenuBar,
    HeaderNotification
  },
  computed: {
    isLogin() {
      return this.$store.getters["front/getLoginStatus"];
    },
    notifications() {
      return this.$store.getters["front/getNotifications"];
    },
     // دریافت محتوای درخواست هوم
    insta() {
      return this.$store.getters["front/getHomeData"]?.settings?.social;
    },
    loading() {
      return this.$store.getters["front/getHomeDataStatus"]?.settings?.social;
    },
  },
  methods: {
    cartListsOpen() {
      cartListsOpen();
      this.$router.push(this.$route.fullPath + "#cart-modal");
    },
    showCloseSearchBox() {
      openSearch();
    },
  },
};
</script>

<style scoped>
.header-icons button {
  padding: 0 12px 0 0;
}
.logo-header{
  transform: translateX(50%);
  position: absolute;
  right: 50%;
}

</style>
